import React, { useState } from 'react'
import Gadjet from '../../images/gadjet.svg'
import SearchNot from '../../images/searchNot.png'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ReportIcon from '@mui/icons-material/Report';
import FemaleIcon from '@mui/icons-material/Female';
import {  CycloneOutlined, DateRange, Sell, Sensors } from '@mui/icons-material'
import EmptyReturn from '../EmptyReturn'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobalContext } from '../Context'
import { addCattleListComment } from '../../redux/slices/listDamSlice'
const moment=require('moment-jalaali')

const CattleList = ({data}) => {
    const dispatch=useDispatch()
    const {cattleListAddComment,commentMode,penCommentMode}=useSelector(state=>state.list)
    const {isModalCommentOpen,openModallComment}=useGlobalContext();
    const handleSelect = (id) => {
        if (cattleListAddComment.includes(id)) {
          dispatch(addCattleListComment(cattleListAddComment.filter((rowId) => rowId !== id)))
        } else {
          dispatch(addCattleListComment([...cattleListAddComment, id]));
        }
       
      };
  return (
    <Container className='allCardsCon'>
        {commentMode&&cattleListAddComment.length&&<div  >
                      <div onClick={openModallComment} className="btnConfirmComment">تایید</div> 
                      </div>}
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
            const {birthdate}=item;
                    const birth=birthdate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
            return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
                
                <div  className='ThemeCard' >
                {commentMode&&<div className='cardCheckS'>
                          <input checked={cattleListAddComment.includes(item.id)} onChange={()=>{
                            handleSelect(item.id)
                          }}  type='checkbox'/>
                        </div>}
                        <div className='d-flex justify-content-between alignItems-center' style={{backgroundColor:'#e5ede5',borderRadius:'10px'}}>
                        <div className='ThemeCardItemm'>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                <span >شماره گوش </span>
                <span>{item?.earTagNumber}</span>
            </div>
            <div className='ThemeCardItemm'>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div> 
                <span >شماره بدن </span>
                <span>{item?.bodyNumber}</span>
            </div>
            <div className='ThemeCardItemm'>
            <div className='LogoFormT'><div><span>
            <Sell/>

                </span>
                    </div></div> 
                <span >شماره گردنبند </span>
                <span>{item?.necklaceNumber?item?.necklaceNumber:'---'}</span>
            </div>
                        </div>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                <span>وضعیت :</span>
                <span>{item?.cattleStatusTitle}</span>
            </div>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <CycloneOutlined/>
                </span>
                    </div></div>
                <span>چرخه دام :</span>
                <span>{item?.cattleLifeCycleTitle}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                <span>سنسور :</span>
                <span>{item?.sensor?.deviceCode}</span>
            </div>
            
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <FemaleIcon/>
                </span>
                    </div></div>
                <span> جنسیت :</span>
                <span>{item?.gender==1?'نر':'ماده'}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>تاریخ تولد :</span>
                <span>{pbirth}</span>
            </div>
            
            <Link to={`${item?.id}`} >
            <div className='btnCardDAm'>
                مشاهده جزئیات
                </div>

            </Link>
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
    </Container>
  )
}

export default CattleList
